import React from "react";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    eyebrow: "Privacy",
    intro: "We take your privacy seriously. This page explains what we collect, why we collect it, and what your rights are.",
    sections: [
      { title: "What we collect", body: "When you fill in a form on this site, we collect the details you give us — usually name, email, company and a description of your project. We use this only to reply to you and, if you become a client, to work with you on your project." },
      { title: "Cookies & analytics", body: "We use a small number of essential cookies for site functionality. We also use Google Analytics to understand how visitors use the site, which helps us improve it. Google Analytics may set cookies and collect information such as your approximate location, device and browsing behaviour on this site. You can opt out at any time." },
      { title: "Your rights", body: "You can request a copy of your data, ask us to correct it, or ask us to delete it at any time. Email hello@solksites.com and we'll act on your request within 30 days." },
      { title: "Third parties", body: "We use trusted providers (Google Analytics, email, hosting). None of them are given permission to use your data for their own marketing." },
    ],
    lastUpdated: "July 2026",
  },
  terms: {
    title: "Terms & Conditions",
    eyebrow: "Terms",
    intro: "The plain-English rules of engagement when you work with SolkSites.",
    sections: [
      { title: "Scope of work", body: "Every project has a written proposal specifying deliverables, timelines and price. If the scope changes mid-project, we agree the change in writing before doing the work." },
      { title: "Payments", body: "Fixed-price projects are billed 50% upfront and 50% on launch. We don't currently offer instalment payment plans." },
      { title: "Ownership", body: "On final payment, you own everything we've built for you — code, design and content. We'll happily hand over all credentials." },
      { title: "Cancellation", body: "You can cancel any project at any time. Fees are non-refundable once work is underway, but you'll receive everything completed to date." },
    ],
    lastUpdated: "July 2026",
  },
  cookies: {
    title: "Cookie Policy",
    eyebrow: "Cookies",
    intro: "A short, honest explanation of the cookies this site uses.",
    sections: [
      { title: "Essential cookies", body: "These make the site work — remembering your theme choice, keeping forms secure. They cannot be switched off." },
      { title: "Analytics cookies", body: "We use Google Analytics to understand which pages help visitors and how the site is used. This data is aggregated and used to improve the site, not to identify you personally." },
      { title: "Manage preferences", body: "You can opt out of analytics cookies at any time, and your browser can block or delete cookies whenever you like. The site will still work — just without personalisation." },
    ],
    lastUpdated: "July 2026",
  },
};

export default function LegalPage({ kind = "privacy" }) {
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} subtitle={c.intro} />
      <section className="pb-24" data-testid={`legal-${kind}`}>
        <div className="container-page max-w-3xl space-y-10">
          {c.sections.map((s) => (
            <div key={s.title}>
              <h2 className="text-xl font-bold text-slate-900 dark:text-white">{s.title}</h2>
              <p className="mt-3 text-slate-600 dark:text-slate-300 leading-relaxed">{s.body}</p>
            </div>
          ))}
          <p className="text-sm text-slate-500 dark:text-slate-400 italic pt-6 border-t border-slate-100 dark:border-slate-800">Last updated: {c.lastUpdated}. If anything's unclear, email inquiries@solksites.com.</p>
        </div>
      </section>
      <CTASection />
    </>
  );
}